import { Typography } from '@curology/ui-components-web/react';
import Image from 'next/image';
import React from 'react';

import providerProfilePicture from '../content/images/provider-profile-picture.png';

const ProviderCard = () => {
  return (
    <div className="cur-flex cur-mt-6 cur-mx-auto cur-max-w-sm">
      <Image
        priority
        src={providerProfilePicture}
        alt="Portrait of Dermatologist, Jennifer Kolinski, smiling"
        quality={100}
        className="cur-w-[76px] cur-h-[76px] cur-my-auto"
      />
      <div className="cur-ml-4">
        <Typography className="cur-mb-1" size="meta" weight="700">
          Jennifer Kolinski, NP-C
        </Typography>
        <Typography size="body" weight="normal">
          Your provider needs to know some basics about your health. Create an
          account to store your info securely. Your answers are private and
          always will be.
        </Typography>
      </div>
    </div>
  );
};

export default ProviderCard;
